import { GET_ACTIVITY_LOGS } from "../../actionTypes";

const initialState = {
  activityLog: [],
  next: "",
  prev: "",
  currentPage: 1,
  last: null,
};

export const activityLogsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ACTIVITY_LOGS:
      return {
        ...state,
        activityLog: payload.data,
        next: payload.next_page_url,
        prev: payload.prev_page_url,
        last: payload.last_page,
        currentPage: payload.current_page,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/actions/activitylogs/activitylog.reducer.js